if (!customElements.get('collection-content-toggle')) {
  customElements.define(
    'collection-content-toggle',
    class CollectionContentToggle extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('.collection-content__toggle');
        if (!button) return;

        button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', expanded);
          button.querySelectorAll('.label-show-more, .label-show-less').forEach((label) => label.classList.toggle('hidden'));
        });
      }
    }
  );
}
